/**
 * Checks if a wheel/scroll event originated from a timeline element
 * @param target - The event target to check
 * @returns true if the event came from a timeline element
 */
export function isTimelineEvent(target: EventTarget | null): boolean {
  const element = target as Element;
  return element?.closest?.('.timeline, fs-timeline, svg.chart') != null;
}
